var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-card',[_c('div',{staticClass:"ant-descriptions-title"},[_vm._v(" Lịch sử hoạt động ")]),_c('i',[_vm._v(" chưa có làm ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }